module.exports = __webpack_public_path__ + "img/box-arrow-up-right.ef15ef07.svg";